import * as AllGames from "../index.js";

export const getTreeGameComponent = (subcategory, stage) => {
    if (subcategory === "Binary Tree") {
        switch (stage.name.toLowerCase()) {
            case "introduction":
                return <AllGames.BinaryTreeIntroduction stage={stage} />;
            case "searching":
                return <AllGames.BinaryTreeSearch stage={stage} />;
            case "insertion / deletion":
                return <AllGames.BinaryTreeInsertDelete stage={stage} />;
            case "binary search tree":
                return <AllGames.BSTOperationsGame stage={stage} />;
            default:
                return <p style={{ color: "black" }}>Παιχνίδι δεν βρέθηκε.</p>;
        }
    }
    else if (subcategory === "Heap") {
        switch (stage.name.toLowerCase()) {
            case "introduction":
                return <AllGames.HeapIntro stage={stage} />;
            case "insertion-deletion":
                return <AllGames.InsertDeleteHeap stage={stage} />;
            case "searching":
                return <AllGames.HeapSearchGame stage={stage} />;
            case "functions":
                return <AllGames.HeapFunctionsGame stage={stage} />;
            default:
                return <p style={{ color: "black" }}>Παιχνίδι δεν βρέθηκε.</p>;
        }
    }
    else if (subcategory === "AVL Tree") {
        switch (stage.name.toLowerCase()) {
            case "introduction":
                return <AllGames.IntroAvl stage={stage} />;
            case "searching":
                return <AllGames.AVLSearch stage={stage} />;
            case "deletion":
                return <AllGames.AVLDeletion stage={stage} />;
            case "insertion":
                return <AllGames.AVLInsertion stage={stage} />;
            default:
                return <p style={{ color: "black" }}>Παιχνίδι δεν βρέθηκε.</p>;
        }
    }

    return <p style={{ color: "black" }}>Δεν υποστηρίζεται αυτό το δέντρο.</p>;
};